var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLink } from 'uitk-react-link';
import { ClickTracker } from 'bernie-analytics';
import { GcHeaderCustomItemSection } from './gc-header-custom-menu-item-section';
export var GcHeaderCustomMenuListItem = function (_a) {
    // const Tag = this.props.typeAnchor ? 'a' : 'span';
    var className = _a.className, id = _a.id, role = _a.role, tabIndex = _a.tabIndex, analytics = _a.analytics, Link = _a.Link, to = _a.to, typeAnchor = _a.typeAnchor, openInNewTab = _a.openInNewTab, href = _a.href, icon = _a.icon, label = _a.label, menuItemSection = _a.menuItemSection, dataStid = _a.dataStid;
    var additionalProps = {
        className: className,
        id: id,
        role: role,
        tabIndex: tabIndex,
        to: to
    };
    /* istanbul ignore next */
    if (Link && to) {
        return React.cloneElement(Link, additionalProps);
    }
    return (React.createElement(ApplicableTag, { isTypeAnchor: typeAnchor, openInNewTab: openInNewTab, link: href, icon: icon, label: label, menuItemSection: menuItemSection, tagProps: additionalProps, className: className, id: id, dataStid: dataStid, analytics: analytics }));
};
export var ApplicableTag = function (_a) {
    var isTypeAnchor = _a.isTypeAnchor, openInNewTab = _a.openInNewTab, newWindowText = _a.newWindowText, link = _a.link, icon = _a.icon, label = _a.label, menuItemSection = _a.menuItemSection, tagProps = _a.tagProps, className = _a.className, id = _a.id, dataStid = _a.dataStid, analytics = _a.analytics;
    var Tag = isTypeAnchor ? 'a' : 'span';
    var hasItemSections = menuItemSection && menuItemSection.subSections && menuItemSection.subSections.length > 0;
    var AnchorLink = function (props) { return React.createElement(Tag, __assign({}, props)); };
    var AnchorLinkTracked = ClickTracker(AnchorLink);
    var screenReaderText = React.createElement("span", { className: "screen-reader-select-hidden is-visually-hidden" }, (newWindowText) || 'Opens in a new window');
    var linkText = (openInNewTab) ? [label, screenReaderText] : label;
    return (React.createElement(React.Fragment, null,
        React.createElement(UitkLink, { className: className },
            React.createElement(AnchorLinkTracked, __assign({ events: "click", href: link, rfrr: analytics && analytics.id, target: openInNewTab ? '_blank' : '_self', linkName: id, trackImmediate: true }, tagProps, isTypeAnchor && { href: link }, { "data-stid": dataStid }),
                icon ? React.createElement(UitkIcon, { name: icon }) : '',
                hasItemSections ? React.createElement(GcHeaderCustomItemSection, { menuItemSection: menuItemSection }) : { linkText: linkText }))));
};
//# sourceMappingURL=gc-header-custom-menu-list-item.js.map